import { processSteps } from "../../mock";

export const HowWeWork = () => (
  <section id="how-we-work" data-testid="how-we-work-section" className="py-24 md:py-32 bg-[#0B1035] border-y border-white/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-violet-400 mb-4">Our Process</p>
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white max-w-2xl">
        From discovery to optimization — we stay in the fight.
      </h2>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-5 gap-8">
        {processSteps.map((step) => (
          <div key={step.num} data-testid={`process-step-${step.num}`} className="border-t border-white/10 pt-6">
            <p className="font-mono text-sm text-violet-400">{step.num}</p>
            <h4 className="mt-3 font-heading text-xl font-medium text-white">{step.title}</h4>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">{step.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
